export default __webpack_public_path__ + "static/media/dimer.ca92082b.png";